import { useRouterState } from '@tanstack/react-router';

import { COMMUNICATION_PAGE_PATH } from '~/features/whatsapp/components/CommunicationPage/constants';

export const useIsCommunicationPage = () =>
    useRouterState({ select: (state) => state.location.pathname === COMMUNICATION_PAGE_PATH });
